module.exports = __webpack_public_path__ + "img/cxample_03.824a3bfc.png";